import "./style.scss";

type TilesPrayerHeaderProps = {
	title: string;
	icon: React.ReactElement;
	info: string;
};

export const TilesPrayerHeader = ({
	icon,
	title,
	info,
}: TilesPrayerHeaderProps) => {
	return (
		<div className="tiles-prayer-header">
			<div className="title-content">
				<p>{title}</p>
				<p>{info}</p>
			</div>

			{icon}
		</div>
	);
};

export default TilesPrayerHeader;
